export default class CouponsService {
  constructor(Api) {
    "ngInject"
    this.api = Api;

  }

  loadCoupons(data) {
    let
      url = '/coupons/list';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  getCoupon(id, type) {
    return this.api.call({
      method: 'get',
      url: '/coupons/get/' + id
    })
  }

  updateCoupon(data, id) {
    let
      url = '/coupons/updateCoupon/' + id;
    return this.api.call({
      method: 'put',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  removeCoupon(id) {
    let
      url = `/coupons/removeCoupons/${id}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  updateCouponStatus(data) {
    let
      url = '/coupons/updateCouponStatus';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  createCoupon(data) {
    let
      url = '/coupons/createCoupon';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/coupons/services/coupon.service.js
 **/